import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { ADMIN_ROLES, EMPLOYEE_ROLES } from '../../constants';

const LoginPage = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setLoading(true);

    try {
      const user = await login({ email, password });
      if (ADMIN_ROLES.includes(user.role)) {
        navigate('/admin/dashboard', { replace: true });
      } else if (EMPLOYEE_ROLES.includes(user.role)) {
        navigate('/employee/reports', { replace: true });
      }
    } catch (err) {
      setError(err?.message || 'Email atau password salah.');
    } finally {
      setLoading(false);
    }
  };

  const isValid = Boolean(email.trim() && password);

  return (
    <div className="lp">
      <div className="lp__circle lp__circle--1" />
      <div className="lp__circle lp__circle--2" />

      <div className="lp__layout">
        <div className="lp__hero">
          <p className="lp__brand-chip">Uniform Management</p>
          <h1 className="lp__title">Portal Administrasi</h1>
          <p className="lp__subtitle">Masuk untuk mengelola data seragam dan pengguna.</p>
        </div>

        <div className="lp__sheet">
          <h2 className="lp__heading">Masuk ke Dashboard</h2>
          <p className="lp__desc">Gunakan akun admin terdaftar.</p>

          <form onSubmit={handleSubmit} className="lp__form">
            {error && (
              <div className="lp__error" role="alert">
                {error}
              </div>
            )}

            <div className="lp__field-wrap">
              <label className="lp__label" htmlFor="login-email">Email</label>
              <div className="lp__field">
                <span className="lp__field-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 7.5C4 6.67 4.67 6 5.5 6h13c.83 0 1.5.67 1.5 1.5v9c0 .83-.67 1.5-1.5 1.5h-13C4.67 18 4 17.33 4 16.5v-9Z" stroke="currentColor" strokeWidth="1.7" />
                    <path d="m5 7 7 5 7-5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
                <input
                  id="login-email"
                  type="email"
                  value={email}
                  onChange={(event) => {
                    setEmail(event.target.value);
                    setError('');
                  }}
                  placeholder="nama@perusahaan.com"
                  autoComplete="email"
                  className="lp__input"
                />
              </div>
            </div>

            <div className="lp__field-wrap">
              <label className="lp__label" htmlFor="login-password">Password</label>
              <div className="lp__field">
                <span className="lp__field-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="4" y="10" width="16" height="10" rx="2" stroke="currentColor" strokeWidth="1.7" />
                    <path d="M8 10V8a4 4 0 1 1 8 0v2" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
                  </svg>
                </span>
                <input
                  id="login-password"
                  type={showPass ? 'text' : 'password'}
                  value={password}
                  onChange={(event) => {
                    setPassword(event.target.value);
                    setError('');
                  }}
                  placeholder="Masukkan password"
                  autoComplete="current-password"
                  className="lp__input"
                />
                <button
                  type="button"
                  className="lp__eye"
                  onClick={() => setShowPass((value) => !value)}
                  aria-label={showPass ? 'Sembunyikan password' : 'Tampilkan password'}
                >
                  {showPass ? 'Hide' : 'Show'}
                </button>
              </div>
            </div>

            <button
              type="submit"
              className="lp__btn"
              disabled={!isValid || loading}
            >
              {loading ? <span className="lp__spinner" /> : 'Masuk'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
